export default __webpack_public_path__ + "static/media/woman.12256c4d.png";